import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m2 2 20 20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M13 13a3 3 0 1 0 0-6H9v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 17v-2.3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ParkingSquareOff";
const ParkingSquareOff = memo(themed(Icon));
export {
  ParkingSquareOff
};
//# sourceMappingURL=parking-square-off.js.map
